import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useBannerList() {
    const { t } = useI18nUtils()
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false },
    ]
    const toast = useToast()
    const awards = ref([])
    const searchQuery = ref('')
    const perPage = ref(10)
    const currentPage = ref(1)
    const totalAwards = ref(0)
    const awardData = ref(null)
    const isAwardFormSidebarActive = ref(false)
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const refAwardListTable = ref(null)
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalAwards.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalAwards.value,
        }
    })

    const updateData = (data) => {
        awardData.value = data
        isAwardFormSidebarActive.value = true
    }

    const refetchData = () => {
        fetchData()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store.dispatch('app-award/getAwards', {
            limit: perPage.value,
            offset: offset,
            keywords: searchQuery.value,
            order_by: 'ordering_count DESC',
            sites_id: getLocalSite.id
        })
        .then(response => {
            awards.value = response.data.data
            totalAwards.value = response.data.total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error fetching Menu' list",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const resolveStatusVariant = status =>{
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const deleteData = async (id) => {
        await store.dispatch('app-award/deleteAward', id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })

            fetchData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Award",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const updateAwardOrdering = () => {
        const filteredData = awards.value?.filter(item => item !== undefined);

        store.dispatch('app-award/updateOrdering', filteredData)
    }

    return {
        searchQuery,
        t,
        tableColumns,
        awards,
        fetchData,
        totalAwards,
        resolveStatusVariant,
        resolveStatusnameVariant,
        updateData,
        awardData,
        isAwardFormSidebarActive,
        refetchData,
        deleteData,
        dataMeta,
        refAwardListTable,
        perPage,
        currentPage,
        updateAwardOrdering,
    }
}